import PropTypes from "prop-types"

// Helper function to get sort direction for ARIA
const getSortDirection = (sorter, field) => {
  if (!sorter || sorter.field !== field) return "none"
  return sorter.order === "ascend" ? "ascending" : "descending"
}

const getHeaders = (sorter) => [
  {
    title: "Date",
    dataIndex: "booked_date",
    key: "booked_date",
    sorter: true,
    width: "15%",
    ellipsis: true,
    "aria-sort": getSortDirection(sorter, "sort_by_date"),
    "aria-label": "Date, sortable"
  },
  {
    title: "Booking ID",
    dataIndex: "booking_id",
    key: "booking_id",
    ellipsis: true,
    width: "15%",
    "aria-label": "Booking ID"
  },
  {
    title: "Experience",
    dataIndex: "title",
    key: "title",
    ellipsis: true,
    sorter: true,
    width: "20%",
    "aria-sort": getSortDirection(sorter, "sort_by_experience"),
    "aria-label": "Experience"
  },
  {
    title: "Amount Spent",
    dataIndex: "trip_price",
    key: "trip_price",
    ellipsis: true,
    width: "20%",
    "aria-label": "Amount Spent",
    sorter: true,
    "aria-sort": getSortDirection(sorter, "sort_by_amount_spent")
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: "120px",
    "aria-label": "Status",
    sorter: true,
    "aria-sort": getSortDirection(sorter, "sort_by_status")
  },
  {
    title: "Actions",
    dataIndex: "actions",
    width: "90px",
    align: "center",
    key: "actions",
    "aria-label": "Actions",
    onCell: () => ({
      onClick: (e) => e.stopPropagation()
    })
  }
]

getHeaders.propTypes = {
  sorter: PropTypes.object
}

export { getHeaders }
